<template>
  <div class="bg-white rounded-2xl shadow-xl border border-gray-100 py-5 px-6 flex flex-col justify-between">
    <p class="text-xs font-semibold uppercase tracking-widest text-gray-400">
      {{ t("team_reward_label") }}
    </p>
    <div>
      <p class="text-4xl font-extrabold tracking-tight text-primary-dark">
        {{ formatPrice(totalReward) }}
      </p>
      <p class="text-sm text-gray-500 mt-1">{{ t("total_earned") }}</p>
    </div>
  </div>
</template>

<script>
import { useI18n } from "vue-i18n";
import { formatPrice } from "@estaly/ui";

export default {
  setup() {
    const { t } = useI18n();
    return { t };
  },

  props: {
    totalReward: {
      type: Number,
      required: true,
    },
  },

  methods: {
    formatPrice,
  },
};
</script>

<i18n src="./TieredChallengeTeamReward.i18n.json"></i18n>
